import * as actions from "./actionTypes";
import * as config from "config";

export function getAllInvoice(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllInvoice,
            method: "post",
            data: params,
            onStart: actions.GET_ALL_INVOICE_START,
            onSuccess: actions.GET_ALL_INVOICE,
            onError: actions.GET_ALL_INVOICE_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function downloadPaymentNotes(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllInvoice,
            method: "post",
            data: params,
            onStart: actions.DOWNLOAD_PAYMENT_NOTES_START,
            onSuccess: actions.DOWNLOAD_PAYMENT_NOTES,
            onError: actions.DOWNLOAD_PAYMENT_NOTES_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getInvoice(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetInvoice + id,
            method: "get",
            data: {},
            onStart: actions.GET_INVOICE_START,
            onSuccess: actions.GET_INVOICE,
            onError: actions.GET_INVOICE_FAILED,
        },
    }
}

export function downloadInvoicePDF(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiDownloadInvoicePDF,
            method: "post",
            data: params,
            onStart: actions.DOWNLOAD_INVOICE_PDF_START,
            onSuccess: actions.DOWNLOAD_INVOICE_PDF,
            onError: actions.DOWNLOAD_INVOICE_PDF_FAILED,
        },
    }
}
